// This file contains the data for the companies that will be displayed on the home page
// The data is an array of objects, each object contains the id and the image of the company

import recoded from '../assets/companies/recoded.png';
import spark from '../assets/companies/spark.png';
import flatiron from '../assets/companies/flatiron.png';
import children from '../assets/companies/children.png';
import unhcr from '../assets/companies/unhcr.png';
import amnesty from '../assets/companies/amnesty.png';
import oxfam from '../assets/companies/oxfam.png';
import giz from '../assets/companies/giz.png';
import unicef from '../assets/companies/unicef.png';

const partners = [
  {
    id: 1,
    image: recoded,
  },
  {
    id: 2,
    image: spark,
  },
  {
    id: 3,
    image: flatiron,
  },
  {
    id: 4,
    image: children,
  },
  {
    id: 5,
    image: unhcr,
  },
  {
    id: 6,
    image: amnesty,
  },
  {
    id: 8,
    image: oxfam,
  },
  {
    id: 9,
    image: giz,
  },
  {
    id: 10,
    image: unicef,
  },
];

export default partners;
